export default "__VITE_PUBLIC_ASSET__aeeae081__"